import React from "react";
import ScrollToTop from "../Component/ScrollToTop";

const Faq = () => {
  return (
    <>
      <ScrollToTop />

      {/* HERO */}
      <section className="bg-light py-5">
        <div className="container text-center">
          <h1 className="fw-bold mb-2">Frequently Asked Questions</h1>
          <p className="text-muted fs-5">
            Find answers to common questions about FreshCart
          </p>
        </div>
      </section>

      {/* FAQ CONTENT */}
      <section className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-9">

            <div className="accordion accordion-flush shadow-sm rounded-4 p-3 bg-white" id="faqAccordion">

              {/* Q1 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                  >
                    🛒 How do I place an order on FreshCart?
                  </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    Simply browse products, add items to your cart, and proceed to checkout.
                    Login is required to place an order.
                  </div>
                </div>
              </div>

              {/* Q2 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                  >
                    🚚 How long does delivery take?
                  </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    Most orders are delivered within <strong>10–60 minutes</strong>,
                    depending on your location and store availability.
                  </div>
                </div>
              </div>

              {/* Q3 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq3"
                  >
                    💳 What payment methods are supported?
                  </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    We support UPI, Cash on Delivery (COD), and selected digital payment options.
                  </div>
                </div>
              </div>

              {/* Q4 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq4"
                  >
                    🔄 Can I cancel or modify my order?
                  </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    Orders can be cancelled within a short time after placing.
                    Once packed or out for delivery, cancellation may not be possible.
                  </div>
                </div>
              </div>

              {/* Q5 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq5"
                  >
                    🔁 What is your refund policy?
                  </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    If you receive a damaged or incorrect product, refunds are processed
                    as per our refund policy within 5-7 business days.
                  </div>
                </div>
              </div>

              {/* Q6 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq6"
                  >
                    👤 Do I need an account to shop?
                  </button>
                </h2>
                <div id="faq6" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    You can browse products without an account, but login is required
                    to add items to cart and place orders.
                  </div>
                </div>
              </div>

              {/* Q7 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq7"
                  >
                    📞 How can I contact customer support?
                  </button>
                </h2>
                <div id="faq7" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    You can reach us via the Contact page or call
                    <strong> +91 7856000970</strong> during support hours.
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;